<template>
  <modal-wrapper
    :open="modelValue"
    @change="handleModalChange"
  >
    <template #default="{ dismiss }">
      <base-wizard
        ref="baseWizardRef"
        @change="handleStepChange"
      >
        <template #default="wizardProps">
          <slot
            name="default"
            v-bind="{
              ...wizardProps,
              dismiss
            }"
          />
        </template>
      </base-wizard>
    </template>
  </modal-wrapper>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import ModalWrapper from '@/shared/legacy/ui/modal-next/modal-wrapper.vue';
import { BaseWizard } from '@/shared/legacy/ui/base-wizard';

defineOptions({
  name: 'BaseWizardModalWrapper'
});

const props = defineProps<{
  modelValue: boolean;
  closeOnStep?: number | null;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  'step-change': [step: number];
}>();

const baseWizardRef = ref<{ prev: () => void } | null>(null);
const currentStep = ref(1);

const handleEscKeyup = (event: KeyboardEvent) => {
  if (event.key !== 'Escape') {
    return;
  }

  if (!props.modelValue) {
    return;
  }

  event.stopPropagation();
  event.preventDefault();
  handleModalChange(false);
};

const handleModalChange = (value: boolean) => {
  if (!value && currentStep.value > 1) {
    if (props.closeOnStep != null && currentStep.value === props.closeOnStep) {
      emit('update:modelValue', false);
      return;
    }

    baseWizardRef.value?.prev();
    return;
  }

  emit('update:modelValue', value);
};

const handleStepChange = (step: number) => {
  currentStep.value = step;
  emit('step-change', step);
};

onMounted(() => {
  window.addEventListener('keyup', handleEscKeyup, { capture: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('keyup', handleEscKeyup, { capture: true });
});
</script>

<i18n lang="json">{}</i18n>
